import { Injectable } from '@angular/core';
import { Router, RoutesRecognized } from '@angular/router';
import { filter, pairwise } from 'rxjs/operators';


/**
 * Service that tracks router events and allows access to the previous route snapshot. Useful for "Back to <whatever>"
 * links that need to be smarter about what they're linking to.
 */
@Injectable()
export class HistoryTrackerService {
  previousUrl: string;
  currentUrl: string;

  constructor(router: Router) {
    router.events.pipe(
      filter(event => event instanceof RoutesRecognized),
      pairwise()
    ).subscribe((events: [RoutesRecognized, RoutesRecognized]) => {
      this.previousUrl = events[0].urlAfterRedirects;
      this.currentUrl = events[1].urlAfterRedirects;
    });
  }
}
